import React from "react";

/**
 * Compact gold pill around entrant name when they lead (or co-lead) a section.
 */
export function SectionLeaderNamePill({ name }) {
    return (
        <span className="inline-flex w-fit max-w-full items-center rounded-full bg-[#ddcf90] px-3 py-1 text-base font-semibold text-masters-forest shadow-sm">
            <span className="truncate">{name}</span>
        </span>
    );
}
